import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import styles from "./searchbox.module.css";
import { Button } from "@walmart-web/livingdesign-components";
import { SEARCH_DROPDOWN_OPTIONS, domain } from "../../store/constants";
import Dropdown from "../dropdown/dropdown";
import { useDispatch, useSelector } from "react-redux";
import { fetchGenAIQueryResponse, setAnswerSpinner } from "../../store/reducers/app";
import { DropdownOptions, GenerativeSearchReq, QueryType } from "../../types";
import { AppDispatch, RootState } from "../../store/store";

function SearchBox() {
  const [queries, setQueries] = useState<DropdownOptions[]>([]);
  const [showError, setShowError] = useState<boolean>(false);
  const [searchQuestion, setSearchQuestion] = useState<string>("");
  const userState = useSelector((state: RootState) => state.userDetails);
  const sessionId = useSelector((state: RootState) => state.sessionId);
  const question = useSelector((state: RootState) => state.currentQuestion);
  const headersAre = useSelector((state: RootState) => state.headers);

  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    const ques = SEARCH_DROPDOWN_OPTIONS.map((question) => {
      return { label: question, value: question };
    });
    setQueries(ques);
  }, []);

  useEffect(() => {
    if (question) {
      setSearchQuestion(question);
    }
  }, [question]);

  const handleEnterSubmit = () => {
    if (searchQuestion.trim().length === 0) {
      setShowError(true);
      setSearchQuestion("");
      return;
    }
    dispatch(setAnswerSpinner({ loading: true, searchQuestion }));
    const payload: GenerativeSearchReq = {
      query: searchQuestion,
      metadata: {
        domain: domain,
        query_id: uuidv4(),
        session_id: sessionId,
        user_id: userState.userId,
        business_unit: userState.businessUnit,
      },
    };
    const logAnswerPayload = {
      sessionId: sessionId,
      queryId: payload.metadata.query_id,
      userId: userState.userId,
      state: userState.state,
      queryType: QueryType.TYPED,
      query: searchQuestion,
      response: "",
      businessUnit: userState.businessUnit,
      createdTimestamp: new Date().toISOString(),
    };
    const reqData = { payload, logAnswerPayload,headers: headersAre };
    dispatch(fetchGenAIQueryResponse(reqData));
  };
  const handleSearchSubmit = () => {
    if (searchQuestion.trim().length === 0) {
      setShowError(true);
      setSearchQuestion("");
      return;
    }
    dispatch(setAnswerSpinner({ loading: true, searchQuestion }));
    const payload: GenerativeSearchReq = {
      query: searchQuestion,
      metadata: {
        domain: domain,
        query_id: uuidv4(),
        session_id: sessionId,
        user_id: userState.userId,
        business_unit: userState.businessUnit,
      },
    };
    const logAnswerPayload = {
      sessionId: sessionId,
      queryId: payload.metadata.query_id,
      userId: userState.userId,
      state: userState.state,
      queryType: QueryType.TYPED,
      query: searchQuestion,
      response: "",
      businessUnit: userState.businessUnit,
      createdTimestamp: new Date().toISOString(),
    };
    const reqData = { payload, logAnswerPayload,headers: headersAre };
    dispatch(fetchGenAIQueryResponse(reqData));
  };

  return (
    <div className={styles.searchField}>
      <div className={styles.searchComponent}>
        <Dropdown
          placeHolder="Ask e-WMMS Assistant"
          ques={searchQuestion}
          setQues={setSearchQuestion}
          questionClicked={question}
          options={queries}
          onEnterClick={handleEnterSubmit}
          err={showError}
          showErr={setShowError}
        />
        <Button variant="primary" onClick={handleSearchSubmit} size="small" type="submit">
          <span className={styles.searchBtnText}>Search</span>
        </Button>
      </div>
      {showError && <span className={styles.errorComponent}>Invalid input.</span>}
    </div>
  );
}

export default SearchBox;
